import { prop } from 'ramda';
import { useCallback } from 'react';
import { useAppSelector } from 'js/store/hooks';
import { getDateForIms } from 'js/hooks/useFormatter/helpers';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useCreatePlayerInfo = () => {
    const send = useGenericSend();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(
        async (request: Types.ICreatePlayerInfoRequestData): Promise<Types.ICreatePlayerInfoResponseData> => {
            const {
                data: { actions, playerCode, userId }
            } = await send<Types.TCreatePlayerInfoRequestData, Types.ICreatePlayerInfoResponseData>({
                ID: 31007,
                responses: [31008, 33006],
                description: 'Create Player Info (Register)',
                errorLevel: 1,
                changeTimestamp: getDateForIms(new Date()),
                ...request,
                casinoName
            });

            return { actions, playerCode, userId };
        }, [
            casinoName,
            send
        ]);
};
